import tw from 'twin.macro' // eslint-disable-line no-unused-vars
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const commonStyles = tw`flex uppercase font-bold tracking-wide block no-underline border border-solid rounded-lg md:inline-block text-center border-gray-500`
const regularSizeStyles = tw`m-4 px-6 py-4`;
const smallSizeStyles = tw`mx-2 mt-3 px-3 py-2 text-xs lg:mt-0 xl:-mt-1 xl:leading-normal xl:text-sm lg:mx-3 lg:px-4 lg:py-2`;

const regularButtonStyles = tw`text-white bg-transparent hover:text-white hover:bg-fog`;
const redButtonStyles = tw`bg-red-500 border-red-500 text-white hover:text-white hover:bg-red-600`;
const specialButtonStyles = tw`text-gray-800 bg-white hover:text-gray-800 hover:bg-gray-200`;
const boldButtonStyles = tw`bg-green-500 border-green-500 text-white hover:text-white hover:bg-green-600`;

const disabledStyles = tw`cursor-not-allowed bg-gray-100 border-gray-500 text-gray-500 hover:text-gray-500 hover:bg-gray-100`;

const ButtonLink = ({ children, to, special, bold, red, small, onClick, disabled, borderLess, ...other }) => {
  const buttonStyles = [commonStyles];

  if (special) {
    buttonStyles.push(specialButtonStyles);
  } else if (bold) {
    buttonStyles.push(boldButtonStyles);
  } else if (red) {
    buttonStyles.push(redButtonStyles);
  } else {
    buttonStyles.push(regularButtonStyles);
  }

  if (small) {
    buttonStyles.push(smallSizeStyles);
  } else {
    buttonStyles.push(regularSizeStyles);
  }

  if (disabled) {
    buttonStyles.push(disabledStyles);
  }

  if (borderLess) {
    buttonStyles.push(tw`border-none`);
  }

  const handleOnClick = e => {
    if (onClick) {
      e.preventDefault();

      if (!disabled) {
        onClick();
      }
    }
  }

  const isExternalLink = new RegExp("^(http|https|mailto):", "i").test(to)
  const isButton = typeof onClick === 'function';

  if (isExternalLink || isButton) {
    return (
      <a href={to || '#'} css={buttonStyles} onClick={handleOnClick} {...other}>
        {children}
      </a>
    )
  }

  return (
    <Link to={to} css={buttonStyles} {...other}>
      {children}
    </Link>
  )
}

ButtonLink.defaultProps = {
  special: false,
  bold: false,
  small: false,
  disabled: false,
  onClick: null,
  borderLess: false
}

ButtonLink.propTypes = {
  to: PropTypes.string,
  special: PropTypes.bool,
  bold: PropTypes.bool,
  small: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  borderLess: PropTypes.bool
}

export default ButtonLink
